/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { GenericOutputParam } from '@karya/core';
import { ComponentNode } from '@karya/generic-task-react';
import { PlatformComponentRenderer } from './platform/Index';
import { UserComponentRenderer } from './user/Index';
import { useEffect } from 'react';

export type ComponentRendererProps = {
  node: ComponentNode;
  writeOutput: (param: GenericOutputParam, value: unknown) => void;
  next: () => void;
  isCurrent: boolean;
  isDocked: boolean;
};
export function ComponentRenderer(props: ComponentRendererProps) {
  // Auto-advance START nodes when they become current
  useEffect(() => {
    if (props.isCurrent && props.node.component.ctype === 'START') {
      props.next();
    }
  }, [props]);

  if (props.node.component.ctype == 'PLATFORM') {
    return <PlatformComponentRenderer {...props} />;
  }
  if (props.node.component.ctype == 'USER') {
    return <UserComponentRenderer {...props} />;
  }

  return null;
}
